import { ProcessMetadata } from '@models/Process/ProcessMetadata';
import { ProcessMode } from '@models/Process/ProcessMode';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AppRouteService {
  constructor(private router: Router) {}

  goTo(fullPagePath: string) {
    this.router.navigate([fullPagePath]);
  }

  goToSignIn(email: string) {
    this.router.navigate(['/signup/sign-in'], { queryParams: { email: email } });
  }

  goToSignAppHome(tab?: string) {
    this.router.navigate(['/pages/home'], { queryParams: { tab } });
  }

  goToSignAppProfile() {
    this.router.navigate(['/pages/profile']);
  }

  goToTask(processId: string) {
    this.router.navigate(['/pages/tasks/info/', processId]);
  }

  goToDocument(processId?: string, nodeRefId?: string) {
    if (!processId || !nodeRefId) {
      this.router.navigate(['/pages/document']);
    } else {
      this.router.navigate(['/pages/document', processId, nodeRefId]);
    }
  }

  goToDepartment(departmentName?: string) {
    if (!departmentName) {
      this.router.navigate(['/pages/department-management']);
    } else {
      this.router.navigate(['/pages/department-management'], {
        queryParams: { departmentName },
      });
    }
  }

  goToWf(processMode: ProcessMode, file?: File) {
    this.router.navigate(['/pages/wf'], { state: { initialData: {processMode, file } } });
  }

  goToWfWithMetadata(processMetadata: ProcessMetadata) {
    this.router.navigate(['/pages/wf'], { state: { initialData: {processMetadata } } });
  }

  goToDuplicateWf(processId: string, generateGroupId: boolean = false) {
    this.router.navigate(['/pages/wf'], { queryParams: { duplicate: processId, generateGroupId: generateGroupId } });
  }

  goToReopenWf(processId: string) {
    this.router.navigate(['/pages/wf'], { queryParams: { reopen: processId } });
  }

  goToEditWf(uuid: string) {
    this.router.navigate(['/pages/wf'], { queryParams: { uuid: uuid } });
  }

  goToUploadWf(nodeRefId: string) {
    this.router.navigate(['/pages/wf'], { queryParams: { nodeRefId: nodeRefId } });
  }

}
